export enum OnboardingActionsType {
    DashboardFederalStates = "dashboard-federal-states",
    PushNotificationAccept = "push-notification-accept",
    PushNotificationDecline = "push-notification-decline",
}
